import React from 'react';
import { PageTitle, StyledTableHeader } from './TabHeaderStyles';
import LoadingMask from '../../../CommonComponents/LoadingMask';

interface Props {
  title?: string;
}

export const TabHeaderLoading: React.FC<Props> = ({ title }) => {
  return (
    <StyledTableHeader>
      <PageTitle>{title || <LoadingMask width="250px" height="24px" isDark />}</PageTitle>
      <LoadingMask width="200px" height="24px" isDark />
    </StyledTableHeader>
  );
};
